import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router";
import { toast } from "react-toastify";
import axios from "axios";

import ModernBanner from "../shopping/component/themes/modern/banner";
import CuteBanner from "../shopping/component/themes/cute/banner";
import ChicBanner from "../shopping/component/themes/chic/banner";
import SimpleBanner from "../shopping/component/themes/simple/banner";
// import DefaultBanner from "../shopping/component/themes/default/banner";
import Viewer from "./helpView/viewer";
import HelpForm from "./component/common/helpForm";
import MediaViewer from "../../../common/mediaViewer";

import { Container } from "../common/styled";
import { ViewerContainer } from "../portfolio/portfolioView/styled";
import { useModal } from "../../../hooks/useModal";
import { useSelector } from "react-redux";

const HelpViewPage = () => {
  const navigate = useNavigate();

  const contentRef = useRef();

  const { helpNo } = useParams();
  const { theme, url: shopUrl } = useOutletContext();
  const { modal, openModal, closeModal } = useModal();
  const user = useSelector((state) => state?.user?.data[0]);

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [formData, setFormData] = useState({ title: "", content: "" });
  const [images, setImages] = useState([]);
  const [isDetail, setIsDetail] = useState(false);
  const [active, setActive] = useState(0);

  useEffect(() => {
    getInquiryDetail();
  }, [helpNo]);

  useEffect(() => {
    if (active) {
      setFormData({ title: data.title, content: data.content, id: data.id });
    }
  }, [active]);

  const banners = {
    0: ModernBanner,
    1: ChicBanner,
    2: ModernBanner,
    3: CuteBanner,
    4: SimpleBanner,
  };

  // 문의 삭제
  const handleDeleteInquiry = () => {
    openModal({
      isOpen: true,
      type: "confirmation",
      title: `문의 삭제`,
      message: [`해당 문의글을 삭제하시겠습니까?`],
      handleConfirm: () => deleteInquiry(),
      handleCancel: () => closeModal(),
    });
  };

  // 문의 삭제
  const deleteInquiry = async () => {
    if (loading) return;
    const url = "/erp/inquiry/delete";
    const body = {
      id: helpNo,
      mberNo: user.mberNo,
    };

    try {
      setLoading(true);
      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("문의글이 삭제되었습니다.");
        closeModal();
        navigate(`/shop/${shopUrl}/shoppingNotice?page=0`, { state: { tabIndex: 1 } });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // 문의 상세 조회
  const getInquiryDetail = async () => {
    if (loading) return;

    const url = "/erp/inquiry";
    const body = { id: helpNo };

    try {
      setLoading(true);
      const res = await axios.post(url, body);
      if (res.status === 200) {
        const data = res.data;

        setData(data);

        if (data?.content) addImageClickEvent();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const addImageClickEvent = () => {
    const images = contentRef.current?.querySelectorAll("img");
    const listeners = [];

    images?.forEach((img) => {
      img.style.cursor = "pointer";

      const listener = () => handleImageClick(img.src);
      img.addEventListener("click", listener);

      listeners.push({ img, listener });
    });

    return () => {
      listeners.forEach(({ img, listener }) => {
        img.removeEventListener("click", listener);
      });
    };
  };

  const handleImageClick = (src) => {
    setImages([src]);
    setIsDetail(true);
  };

  const renderComponent = () => {
    const Banner = banners[theme];
    return Banner && <Banner />;
  };

  const cancelEvent = () => {
    setFormData({ title: "", content: "" });
    setActive(0);
  };

  const getInquiries = () =>
    navigate(`/shop/${shopUrl}/shoppingNotice?page=0`, { state: { tabIndex: 1 } });

  const handleEdit = () => {
    setActive(1);
  };

  return (
    <Container className={`theme-${theme}`}>
      {modal}
      {renderComponent()}
      {isDetail && <MediaViewer files={images} setIsOpen={setIsDetail} />}
      <ViewerContainer className={`theme-${theme}`}>
        <h3>
          <span>1:1 문의{active === 1 && " 수정"}</span>
        </h3>
        {
          [
            <Viewer
              data={data}
              handleDeleteInquiry={handleDeleteInquiry}
              handleEdit={handleEdit}
              contentRef={contentRef}
            />,
            <HelpForm
              formData={formData}
              setFormData={setFormData}
              openModal={openModal}
              closeModal={closeModal}
              getInquiries={getInquiries}
              cancelEvent={cancelEvent}
            />,
          ][active]
        }
      </ViewerContainer>
    </Container>
  );
};

export default HelpViewPage;
